import type { TaskPayload, TaskStep } from "./domain";
export interface TaskStepPolicy { version: number; price_range?: { min_amount_minor: number; max_amount_minor: number }; default_steps: TaskStep[]; asset_urls?: Record<string, string> }
export const usesDefaultTaskSteps = (payload: TaskPayload) => payload.steps_mode === "default" || !payload.steps.length;
export function previewWithDefaultSteps(payload: TaskPayload, policy?: TaskStepPolicy): TaskPayload {
  return usesDefaultTaskSteps(payload) ? { ...payload, steps_mode: "default", steps: policy?.default_steps || [] } : payload;
}
